module.exports = __webpack_public_path__ + "img/5.504accf1.jpg";